import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row.quality');

const RecentlyActiveInMyGreenhouseCheckbox = () => {
  const { watch, setValue } = useFormContext();
  const recentlyActive: boolean = watch('recently_active_in_my_greenhouse');

  return (
    <Checkbox
      data-provides={'talent-matching-recently-active-checkbox'}
      checked={recentlyActive}
      onChange={(checked) =>
        setValue('recently_active_in_my_greenhouse', checked, {
          shouldDirty: true,
        })
      }
      label={t('recently_active_in_my_greenhouse')}
      helperText={t('recently_active_in_my_greenhouse_helper_text')}
      value={'recently_active_in_my_greenhouse'}
    />
  );
};

export default RecentlyActiveInMyGreenhouseCheckbox;
